import { create } from "zustand";

/**
 * The Feed's one sound switch (2026-09-13). Unmute a post and the next one you scroll
 * to plays with sound too — the choice is the page's, not the post's (owner: "if I click
 * unmute and I scroll to the next video that should also be on unmute"). Starts muted,
 * the browser's autoplay rule; the first tap on a sound button is the gesture that lets
 * every later post autoplay audible. Page-life only: a reload has no gesture behind it.
 */
export const useFeedSound = create<{ muted: boolean; setMuted: (muted: boolean) => void }>((set) => ({
  muted: true,
  setMuted: (muted) => set({ muted }),
}));
